const filesProjectionExpression = [
  'id',
  'usuario',
  'fileNumber',
  'fileExtend',
  'startDateFile',
  'lstPaX.flightIds',
  'lstPaX.Pax',
  'lstPaX.estado',
  'lstPaX.grupo',
  'lstPaX.grupoId',
  'lstPaX.acumulado',
  'lstPaX.paxMenu.menu.id',
  'lstPaX.paxMenu.menu.nombreMenu',
  'lstPaX.paxMenu.observaciones',
  'lstPaX.type',
  'lstPaX.passengerId',
  'estadoItinerario',
  'lastMinute',
  'pendingPreOpIncidents',
  'estadoFile',
  'nameClient',
  'filePadreId',
  'nombreItinerario',
  'isSSFFPadre',
  'dateRange',
  'diasItinerario'
];
const itineraryProjectionFields = ['id', 'fileNumber'];

const flightsProjectionFields = [
  'id',
  'itineraryId',
  'flightNumber',
  'isExplorandesFlight',
  'flightCode',
  'flightDate',
  'arrivalTime',
  'departureTime',
  'airline'
];

export const BIBLIA_PROJECTION_EXPRESSIONS = {
  files: filesProjectionExpression,
  itineraries: itineraryProjectionFields,
  flights: flightsProjectionFields
};
